import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import {Consumer} from '../../context'
import Icon from '../icon'


export default function SubMenuItem ({order,page, direction, selected, query, items}) {

  const menuClasses = useMenuClasses(direction)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const openSubMenu = e => setAnchorEl(e.currentTarget)
  const closeSubMenu = () => setAnchorEl(null)
  const toggleMenu = e => anchorEl === null ? openSubMenu(e) : closeSubMenu()

  return (<Consumer>{ context => {
    const {languageId, role, translate, link} = context

    return (
      <Box
        className="submenu"
        onClick={toggleMenu}
      >
        <Menu
          id={`submenu-${order}`}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={closeSubMenu}
          PopoverClasses={menuClasses}
        >
          {items.map((item, index) => {
            const {page, section} = item
            const href = link(
              {languageId, role, page, section},
              '/:languageId/:role/:page/:section?',
              {query: query ? pick(context, query) : undefined}
            )

            const handleClick = e => {
              if (context.page == page) e.preventDefault()
            }

            return (
              <MenuItem key={index}>
                <Link className="link" to={href} onClick={handleClick}>
                  {translate(item.label)}
                </Link>
              </MenuItem>)
          })}
        </Menu>
        <Box
          className={clsx("menu-item", direction, {selected})}
        >
          <Icon name={page} />
          <label>
            {translate(`${page}_title`)}
          </label>
        </Box>
    </Box>

  )}}</Consumer>)
}

const useVerticalMenuClasses = makeStyles(menuStyles('vertical'))
const useHorizontalMenuClasses = makeStyles(menuStyles('horizontal'))

function useMenuClasses (direction = 'vertical') {

  const styles = {
    vertical: useVerticalMenuClasses(),
    horizontal: useHorizontalMenuClasses()
  }

  const [classes, setClasses] = React.useState(styles[direction])

  React.useEffect(() => {
    setClasses(styles[direction])
  }, [direction])

  return classes
}

function menuStyles (direction) {

  const props = {
    horizontal: {
      marginTop: -10,
      marginLeft: 20
    },
    vertical: {
      borderTopLeftRadius: 0,
      marginLeft: 74,
      marginTop: -89
    }
  }

  return (theme) => ({
    root: {
      zIndex: '5000 !important'
    },
    paper: {
      "& .link": {
        textDecoration: 'none',
        color: '#fff',
      },
      backgroundColor: '#2c75bd',
      borderBottomLeftRadius: 0,
      ...(props[direction])
    }
  })
}
